module.exports = __webpack_public_path__ + "img/open.8fb622fb.svg";